export default "__VITE_ASSET__MF6C7QuFuFy3IL8iZK9YWA__";